<template>
  <Modal v-model="modal" :title="safe.MobliePhone?$t('title.w24'):$t('title.w25')" :mask-closable="false">
    <div>
      <!-- 修改 -->
      <Form label-position="top" v-if="mode=='edit'" :model="form1" ref="edit" :rules="form1Rules">
        <FormItem :label="`${$t('label.w37')} (${safe.MobliePhone})`" prop="oldPhoneCode">
          <Row type="flex" :gutter="10">
            <Col span="18">
              <Input  :placeholder="$t('pl.p28')" v-model="form1.oldPhoneCode"/>
            </Col>
            <Col span="6">
              <Codebtn type="SendUpdateOldPhoneCode"/>
            </Col>
          </Row>
        </FormItem>
        <FormItem :label="$t('label.w38')" prop="mobliePhone1">
          <!-- <Input :placeholder="$t('pl.p7')" v-model="form1.mobliePhone1"/> -->
          <Input v-model="form1.mobliePhone1" :placeholder="$t('pl.p7')">
            <Select v-model="form1.areacode" slot="prepend" style="width: 80px">
              <Option value="0086">0086</Option>
              <Option value="00852">00852</Option>
            </Select>
          </Input>
        </FormItem>
        <FormItem :label="$t('label.w39')" prop="newPhoneCode">
          <Row type="flex" :gutter="10">
            <Col span="18">
              <Input :placeholder="$t('pl.p28')" v-model="form1.newPhoneCode"/>
            </Col>
            <Col span="6">
              <Codebtn
                type="SendUpdateNewPhoneCode"
                :to="form1.mobliePhone1"
                :disabled="form1.mobliePhone1==''"
                :phoneAreaCode="form1.phoneAreaCode"
              />
            </Col>
          </Row>
        </FormItem>
      </Form>

      <!-- 新绑定 -->
      <Form label-position="top" :model="form" ref="new" :rules="formRules" v-else>
        <FormItem :label="`${$t('label.w36')} (${safe.Email})`" prop="emailCode">
          <Row type="flex" :gutter="10">
            <Col span="18">
              <Input :placeholder="$t('pl.p31')" v-model="form.emailCode"/>
            </Col>
            <Col span="6">
              <Codebtn type="SendBindPhoneEmailCode"/>
            </Col>
          </Row>
        </FormItem>
        <FormItem :label="$t('label.w40')" prop="mobliePhone">
          <!-- <Input :placeholder="$t('pl.p7')" v-model="form.mobliePhone"/> -->
          <Input v-model="form.mobliePhone" :placeholder="$t('pl.p7')">
            <Select v-model="form.areacode" slot="prepend" style="width: 80px">
              <Option value="0086">0086</Option>
              <Option value="00852">00852</Option>
            </Select>
          </Input>
        </FormItem>
        <FormItem :label="$t('label.w35')" prop="phoneCode">
          <Row type="flex" :gutter="10">
            <Col span="18">
              <Input :placeholder="$t('pl.p28')" v-model="form.phoneCode"/>
            </Col>
            <Col span="6">
              <Codebtn
                type="SendBindPhoneCode"
                :to="form.mobliePhone"
                :disabled="form.mobliePhone==''"
                :phoneAreaCode ="form.phoneAreaCode"
              />
            </Col>
          </Row>
        </FormItem>
      </Form>
    </div>
    <template slot="footer">
      <Button type="primary" @click="submit">{{$t('btn.b5')}}</Button>
    </template>
  </Modal>
</template>

<script>
import Codebtn from "@/components/sendCodeButton";
import formRule from "@/libs/formRule";
export default {
  components: { Codebtn },
  data() {
    return {
      modal: false,
      form: {
        phoneCode: "",
        mobliePhone: "",
        emailCode: "",
        areacode:"0086"
      },
      formRules: {
        phoneCode: formRule.code,
        mobliePhone: formRule.logPhone,
        emailCode: formRule.code
      },
      form1: {
        oldPhoneCode: "",
        // 使用mobliePhone1 防止FormItem的prop属性冲突
        mobliePhone1: "",
        newPhoneCode: "",
        areacode:"0086"
      },
      form1Rules: {
        oldPhoneCode: formRule.code,
        mobliePhone1: formRule.logPhone,
        newPhoneCode: formRule.code
      }
    };
  },
  methods: {
    async submit() {
      let valid = await this.$refs[this.mode].validate();
      if (!valid) return;
      let res;
      if (this.mode == "edit") {
        res = await this.$axios.post("/Member/RZJProfile/UserUpdateBindPhone", {
          oldPhoneCode: this.form1.oldPhoneCode,
          mobliePhone: this.form1.mobliePhone1,
          newPhoneCode: this.form1.newPhoneCode,
          phoneAreaCode: this.form1.areacode
        });
      } else {
        res = await this.$axios.post(
          "/Member/RZJProfile/UserBindMobliePhone",
          this.form
        );
      }
      if (res.err) return res.throw();
      // 重新获取状态
      this.$store.dispatch("user/getSafe");
      this.$Message.success(
        this.mode == "edit" ? this.$t('msg.m35') : this.$t('msg.m36')
      );
      this.modal = false;
    }
  },
  computed: {
    safe() {
      return this.$store.state.user.safe;
    },
    mode() {
      return this.safe.MobliePhone ? "edit" : "new";
    }
  },
  watch: {
    modal(v) {
      this.$refs[this.mode].resetFields();
    }
  }
};
</script>

